import {
  makePaymentRecurringElem,
  makePaymentRecurringButtonElem,
  makePaymentDashboardPaymentButtonElem,
  makePaymentDashboardTrackUrlData
} from './constants'

export function paymentDashboardRecurringShow () {
  makePaymentRecurringElem.removeClass('hide')
  paymentDashboardRecurringAttachClick()
}

export function paymentDashboardRecurringHide () {
  makePaymentRecurringElem.addClass('hide')
}

function paymentDashboardRecurringAttachClick () {
  makePaymentRecurringButtonElem.on('click', function(_evt) {
    makePaymentDashboardPaymentButtonElem.trigger('click')
    $.post(makePaymentDashboardTrackUrlData)
  })
}
